/**
 * Intro step (used for both greeting screens): mascot + speech bubble + primary CTA.
 * See specs/onboarding-questionnaire/spec.md (Story 1).
 */

import { View, Text, Pressable } from 'react-native';
import { AnimatedMonkey } from '../../AnimatedMonkey/AnimatedMonkey';
import { onboardingStyles as s } from '../OnboardingFlow.styles';
import { ONBOARDING_TEST_IDS } from '../OnboardingFlow.constants';
import { BackButton } from './BackButton';

interface IntroStepProps {
  text: string;
  ctaLabel: string;
  onNext: () => void;
  onBack: () => void;
}

export function IntroStep({ text, ctaLabel, onNext, onBack }: IntroStepProps) {
  return (
    <>
      <View style={s.topRow}>
        <BackButton onPress={onBack} />
      </View>

      <View style={s.introBody}>
        <View style={s.speechBubble}>
          <Text style={s.speechText}>{text}</Text>
        </View>
        <AnimatedMonkey size={190} style={s.introMascot} />
      </View>

      <View style={s.footer}>
        <Pressable
          onPress={onNext}
          testID={ONBOARDING_TEST_IDS.INTRO_CTA}
          accessibilityRole="button"
          accessibilityLabel={ctaLabel}
          style={({ pressed }) => [s.primaryButton, pressed && s.pressed]}
        >
          <Text style={s.primaryButtonText}>{ctaLabel}</Text>
        </Pressable>
      </View>
    </>
  );
}
